import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonInfiniteScroll } from '@ionic/angular';
import { BasePage } from 'src/app/lib/base-page';
import { Videos } from 'src/app/models/mobility';
import { LoaderService } from 'src/app/services/loader.service';
import { MobilityService } from 'src/app/services/mobility.service';

@Component({
  selector: 'app-mobility-videos-from-tags',
  templateUrl: './mobility-videos-from-tags.page.html',
  styleUrls: ['./mobility-videos-from-tags.page.scss'],
})
export class MobilityVideosFromTagsPage extends BasePage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll
  videos: Videos[] = []
  numberOfVideos: number = 0
  url: string = 'pepe'
  tag: string
  disabled: boolean = false
  page: number = 1
  pageSize: number = 24
  dataLoaded = false
  constructor(private mobilityService: MobilityService,
    private route: ActivatedRoute, private loaderService: LoaderService) {
    super()
  }

  ngOnInit() {
    this.getData()
  }

  async getData(){
    await this.loaderService.loader();
    this.route.paramMap.subscribe(param => {
      this.url = param.get('tag')
      this.mobilityService.getHashtagVideos(this.url,this.page,this.pageSize).subscribe(async res => {
        await this.loaderService.dismiss()
        this.videos = res.data.videos
        this.tag = res.data.hashtag_name
        this.numberOfVideos = res.data.amount_videos
        this.disabled = this.numberOfVideos < this.page * this.pageSize ? true : false
        this.page = 3
        this.pageSize = 12
        this.dataLoaded = true
      })
    })
  }

  scrollReached(event){
    setTimeout(() => {

      if(!this.disabled){
        this.mobilityService.getHashtagVideos(this.tag,this.page,this.pageSize).subscribe(res => {
          this.videos = this.videos.concat(res.data.videos)
        })
        this.disabled = this.numberOfVideos < this.page * this.pageSize ? true : false
        this.page++
      }
      event.target.complete();
    }, 500);
  }
}
